import { useContext, useEffect, useState } from "react"

import { CommonListType, IDictSelectorContainer, IDictSelectorUI } from "./types"
import { DictSelectorUI } from "./ui"

import { useDict } from "@api/dict/state"
import { useValue } from "@hooks/useValue"


import { NotificationContext, notifyOpen } from "@ui/notification/notification.provider"


/** Контейнер - Выбор данных из справочника */
export const DictSelectorContainer = ({ dbName, dictName, isSearch = true, isScroll = true, whereParam1, whereParam2, children, onSelect }: IDictSelectorContainer) => {
    const notify = useContext(NotificationContext)
    const [isOpen, setIsOpen] = useState(false)

    const { 
        isLoading, error, clearDictState,
        actionGetCoursesContract, actionGetContractProgramInfo, actionGetCourses, actionGetProgramType, actionGetAttestationType, actionGetVolumeHours,  
        actionGetApplicationStatuses, actionGetApplicationType, actionGetApplicationSource, actionGetCitizenships,
        actionGetEducationLevels, actionGetApplicationsNumber, actionGetContractsStatuses, actionGetContractTypes, 
        actionGetContractViews, actionGetDocumentTypes, actionGetPrintStatus, actionGetCommercialOffersStatuses,
        actionGetAccessLevels, actionGetAccessSites, actionGetAccessSections, actionGetContractSignatureStatuses
    } = useDict()
    
    const headerText = useValue<string>('')
    const txtSearch = useValue<string>('')

    const selectedID = useValue<number>(0)
    const commonList = useValue<CommonListType[]>([])


    useEffect(() => {
        if (isOpen) {
            switch (dictName) {
                case 'courses': { // Наименование программы (Курсы)
                    actionGetCourses(dbName || '').then((res) => {
                        commonList.setValue(res.filter((fil) => fil.courseProgramID).map((item) => {
                            return ({
                                id: item.courseID,
                                name: item.courseName,
                                param1: item.courseProgramID.toString(),
                                param2: item.programID.toString(),
                                param3: item.programName,
                                param4: item.durationEducation,
                                param5: item.volumeHours,
                                param6: item.price
                            })
                        }))
                    })
                    headerText.setValue('Выбор курса')
                    break
                }

                case 'coursesContract': { // Наименование программы (Курсы) по договору
                    actionGetCoursesContract(dbName || '').then((res) => {
                        commonList.setValue(res.map((item) => {
                            return ({
                                id: item.courseID,
                                name: item.courseName,
                                param1: item.sphere,
                                param2: item.qualification,
                                param3: item.requirementName,

                                param4: item.durationEducation,
                                param5: item.volumeHours,
                                param6: item.price,
                                
                                param7: item.courseProgramID.toString(),
                                param8: item.programID.toString(),
                                param9: item.programName,
                            })
                        }))
                    })
                    headerText.setValue('Выбор курса')
                    break
                }

                case 'contractProgramInfo': { // Информация по программе для договора
                    actionGetContractProgramInfo(dbName || '', Number(whereParam1)).then((res) => {
                        commonList.setValue(res.map((item) => {
                            return ({
                                id: item.courseProgramID,
                                name: item.programName,
                                param1: item.programID.toString(),
                                param2: item.durationEducation,
                                param3: item.volumeHours,
                                param4: item.price,
                            })
                        }))
                    })
                    headerText.setValue('Выбор программы по курсу')
                    break
                }

                case 'programType': { // Тип программы
                    actionGetProgramType(dbName || '', Number(whereParam1)).then((res) => {
                        commonList.setValue(res.filter((fil) => fil.courseProgramID).map((item) => {
                            return ({
                                id: item.programID,
                                name: item.programName,
                                param1: item.courseProgramID.toString(),
                                param2: item.attestationTypeID.toString(),
                                param3: item.attestationTypeName,
                                param4: item.durationEducation,
                                param5: item.volumeHours,
                                param6: item.price
                            })
                        }))
                    })
                    headerText.setValue('Выбор типа программы')
                    break
                }

                case 'attestationType': { // Тип аттестации
                    actionGetAttestationType().then((res) => {
                        commonList.setValue(res.map((item) => {
                            return ({
                                id: item.attestationTypeID,
                                name: item.attestationTypeName,
                            })
                        }))
                    })
                    headerText.setValue('Выбор типа аттестации')
                    break
                }

                case 'volumeHours': { // Обьемы часов по программе
                    actionGetVolumeHours(dbName || '', Number(whereParam1), Number(whereParam2)).then((res) => {
                        commonList.setValue(res.map((item) => {
                            return ({
                                id: item.courseProgramID,
                                name: item.volumeHours,
                                param1: item.durationEducation,
                                param2: item.price,
                            })
                        }))    
                    })
                    headerText.setValue('Выбор объёма часов')
                    break
                }

                case 'applicationStatus': { // Статусы заявки
                    actionGetApplicationStatuses().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.applicationStatusID,
                            name: item.applicationStatusName,
                            param1: item.applicationStatusColor,
                        })))    
                    })
                    headerText.setValue('Выбор статуса заявки')
                    break
                }

                case 'applicationType': { // Тип заявки
                    actionGetApplicationType().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.applicationTypeID,
                            name: item.applicationTypeName,
                        })))
                    })
                    headerText.setValue('Выбор типа заявки')
                    break
                }

                case 'applicationSource': { // Источник заявки
                    actionGetApplicationSource().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.applicationSourceID,
                            name: item.applicationSourceName,
                        })))
                    })
                    headerText.setValue('Выбор источника заявки')
                    break
                }

                case 'applicationsNumber': { // Номера заявок
                    headerText.setValue('Выбор номера заявки')
                    break
                }

                case 'citizenship': { // Гражданство
                    actionGetCitizenships().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.citizenshipID,
                            name: `${item.citizenshipCode} - ${item.citizenshipName}`,
                        })))    
                    })
                    headerText.setValue('Выбор гражданства')
                    break
                }

                case 'educationLevel': { // Уровень образования
                    actionGetEducationLevels().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.educationLevelID,
                            name: item.educationLevelName,
                        })))
                    })
                    headerText.setValue('Выбор уровень образования')
                    break
                }

                case 'contractStatus': { // Статус договора
                    actionGetContractsStatuses().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.contractStatusID,
                            name: item.contractStatusName,
                        })))
                    })
                    headerText.setValue('Выбор статуса договора')
                    break
                }

                case 'contractType': { // Тип договора
                    actionGetContractTypes().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.contractTypeID,
                            name: item.contractTypeName,
                        })))
                    })
                    headerText.setValue('Выбор тип договора')
                    break
                }

                case 'contractView': { // Вид договора
                    actionGetContractViews().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.contractViewID,
                            name: item.contractViewName,
                        })))
                    })
                    headerText.setValue('Выбор вид договора')
                    break
                }

                case 'documentTypes': { // Тип программы
                    actionGetDocumentTypes().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.documentTypeID,
                            name: item.documentTypeName,
                        })))
                    })
                    headerText.setValue('Тип программы')
                    break
                }

                case 'printStatus': { // Статус печати
                    actionGetPrintStatus().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.printStatusID,
                            name: item.printStatusName,
                        })))
                    })
                    headerText.setValue('Статус печати')
                    break
                }

                case 'commercialOffersStatus': { // Статусы коммерческих предложений
                    actionGetCommercialOffersStatuses().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.commercialOffersStatusID,
                            name: item.commercialOffersStatusName,
                            param1: item.commercialOffersStatusColor,
                        })))    
                    })
                    headerText.setValue('Выбор статуса ком. предложения')
                    break
                }

                case 'accessLevels': { // Должность операторов
                    actionGetAccessLevels().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.accessLevelID,
                            name: item.accessLevelName,
                        })))
                    })
                    headerText.setValue('Должность оператора')
                    break
                }

                case 'accessSites': { // Доступные сайты
                    actionGetAccessSites().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.siteDbNameID,
                            name: item.siteDbNameDescription,
                            param1: item.siteLink,
                            param2: item.siteDBName
                        })))
                    })
                    headerText.setValue('Доступные сайты')
                    break
                }

                case 'accessSections': { // Доступные разделы
                    actionGetAccessSections().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.accessSectionID,
                            name: item.accessSectionName,
                            param1: item.accessSectionDescription
                        })))
                    })
                    headerText.setValue('Доступные разделы')
                    break
                }

                case 'signatureStatus': { // Доступные разделы
                    actionGetContractSignatureStatuses().then((res) => {
                        commonList.setValue(res.map((item) => ({
                            id: item.contractStatusCallCenterID,
                            name: item.contractStatusCallCenterName,
                            param1: item.contractStatusCallCenterColor
                        })))
                    })
                    headerText.setValue('Статус договора на подпись')
                    break
                }

            }
        }
        
        !isOpen && clearDict()
    }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!isOpen || dictName !== 'applicationsNumber') return

        let isCurrentRequest = true
        const timeoutID = setTimeout(() => {
            actionGetApplicationsNumber(whereParam1 || '', txtSearch.value).then((res) => {
                if (!isCurrentRequest) return

                commonList.setValue(res.map((item) => ({
                    id: item.applicationID,
                    name: `${item.applicationID.toString()} - ${item.siteName}`,
                    param1: item.dataBaseName,
                    param2: item.siteName
                })))
            })
        }, txtSearch.value ? 300 : 0)

        return () => {
            isCurrentRequest = false
            clearTimeout(timeoutID)
        }
    }, [isOpen, dictName, txtSearch.value, whereParam1]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        // if (error) return notify && notifyOpen(error?.message, error?.type, 3000, notify)
    }, [error]) // eslint-disable-line react-hooks/exhaustive-deps


    /** Функция обнуления данных по справочнику */
    const clearDict = () => {
        clearDictState()

        headerText.setValue('')
        txtSearch.setValue('')

        selectedID.setValue(0)
        commonList.setValue([])
    }

    /** Нажатие на кнопку выбрать */
    const handleButtonOk = (selectedID: number) => {
        const selectedRowToList = commonList.value.filter(val => val.id === selectedID)
        if (selectedRowToList.length === 0) return notify && notifyOpen('Для продолжения необходимо выбрать значение из справочника.', 'info', 3000, notify)

        onSelect({
            id: selectedRowToList[0].id,
            name: selectedRowToList[0].name, 
            param1: selectedRowToList[0].param1, 
            param2: selectedRowToList[0].param2, 
            param3: selectedRowToList[0].param3, 
            param4: selectedRowToList[0].param4, 
            param5: selectedRowToList[0].param5, 
            param6: selectedRowToList[0].param6,
            param7: selectedRowToList[0].param7,
            param8: selectedRowToList[0].param8,
            param9: selectedRowToList[0].param9,
        })

        setIsOpen(false)
    }

    /** Свойства передаваемые в компоненту */
    const propsToUI: IDictSelectorUI = {
        isOpen, isLoading, isSearch, isScroll,
        txtSearch, dictName,
        selectedID, commonList,
        setIsOpen, handleButtonOk,
    }
    return <>
        <DictSelectorUI {...propsToUI}>
            {children}
        </DictSelectorUI>
    </>
}